import {Landmark} from "./landmarks";
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';

export function sendLandmark(landmark: Landmark) {
    LandmarkAdapter.sendLandmark(landmark);
}